import AbstractApiCommand from './AbstractApiCommand';
import ApiReceiver from './ApiReceiver';

class PutCommand<T> extends AbstractApiCommand<T> {
  private readonly path: string;
  private readonly data: T;
  private readonly identifier: string;

  constructor(apiReceiver: ApiReceiver, path: string, data: T, identifier: string) {
    super(apiReceiver);
    this.path = path;
    this.data = data;
    this.identifier = identifier;
  }

  // AbstractApiCommand
  handleRunCommand(): Promise<T> {
    return this.handleApiCall(this.path, this.data);
  }

  handleApiCall(path: string, data: T): Promise<T> {
    return this.apiReceiver.putData<T>(path, data);
  }

  getDataStringRepresentation(): string | null {
    return JSON.stringify(this.data);
  }

  getIdentifier(): string | null {
    return this.identifier;
  }
}

export default PutCommand;
